const initialize = function(formId, eventName, source, emailId, successMessageId, emailFieldWrapperId, eventProperties, loadingMessageId, klaviyoListId) {
  const klaviyoSubscribe = async (userEmail, listId) => {
    await fetch(`https://manage.kmail-lists.com/ajax/subscriptions/subscribe`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: new URLSearchParams({
        g: listId,
        email: userEmail,
        $source: "-4", // Embedded Form https://help.klaviyo.com/hc/en-us/articles/1260804673530
        $fields: "$source, email",
      })
    })
      .catch((error) => {
        console.error('Error calling Klaviyo:', error);
      });
  };

  const klaviyoEvent = async (eventName, eventProperties, userEmail) => {
    if (!window.klaviyo) {
      console.error('No klaviyo object available');
      return;
    }

    if (userEmail) {
        await klaviyo.identify({
          'email' : userEmail,
        });
    }

    klaviyo.push(['track', eventName, eventProperties]);
  };

  const cordialSubscribe = (email, signUpSource, eventName, eventProperties) => {
    let auth_data = {
      'email': email
    };

    let contact_data = {
      'channels': {
        'email': {
          'subscribeStatus': 'subscribed'
        }
      },
      'signup_source': signUpSource
    };

    let options = {
      'forceSubscribe': { 'email': true },
      'upsert': true
    };

    crdl('contact', auth_data, contact_data, options);

    if (eventName) {
      crdl('event', eventName, eventProperties);
    }
  }

// Define a shared setup function that can be called now or when the crdl function is available
  const setup = () => {
    // Show the form on initialize. This prevents people from filling out the form before the page is fully ready.
    // Submitting the form before this js downloads and runs prevents signups from working
    document.getElementById(formId).classList.remove('bbhidden');
    document.getElementById(loadingMessageId).classList.add('bbhidden');

    // Add a submit event listener to the form
    document.getElementById(formId).addEventListener('submit', async (event) => {
      event.preventDefault();

      const email = document.getElementById(emailId).value;

      // Delay cordial events until cordial is ready
      if (!window.crdl) {
        window.addEventListener(
          'cordialLoaded',
          function() {
            cordialSubscribe(email, source, eventName, eventProperties);
          }
        );
      } else {
        cordialSubscribe(email, source, eventName, eventProperties);
      }

      // Also call Klaviyo and subscribe the user
      await klaviyoSubscribe(email, klaviyoListId);
      // Send event to Klaviyo
      await klaviyoEvent(
        eventName === 'email_signup' ? 'footer_signup': eventName, // We can probably just pass in footer_signup once we're off of cordial
        {},
        email
      );

      Shopify.analytics.publish('subscribe_form_submit');

      if (successMessageId && emailFieldWrapperId) {
        document.getElementById(successMessageId).classList.remove('bbhidden');
        document.getElementById(emailFieldWrapperId).classList.add('bbhidden');
      }

      return false;
    });
  };

  setup();
};

export default { initialize };